import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetFacetsPanelCollapsedMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.setFacetsPanelCollapsed]: ({ facetsGroups }: SearchState,
      { panelId, collapsed }: { panelId: string, collapsed: boolean }) => {
      facetsGroups[panelId].collapsed = collapsed;
    }
  };
}
